import React, { useState } from 'react';
import classNames from 'classnames';
import { List, Map } from 'immutable';

import { Paragraph, View } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import Hero from '../../../components/Hero';
import { TESTIMONIAL_VIEW_ID, TESTIMONIAL_VIEW_BLOCK_3 } from '../../../config/constants';

const NodeBasicPage = ({ entity, className }) => {
  const [currentPage, setCurrentPage] = useState(0);

  const classes = classNames(className, 'BasicPage');

  const type = entity.getIn(['type', 0, 'target_id'], '');

  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed'], '');
  const buttons = entity.get('field_buttons');
  const imageField = entity.getIn(['field_media_item', 0], Map());

  return (
    <article className={classes} itemScope itemType="https://schema.org/WebPage">
      <Hero title={title} body={body} imageField={imageField} type={type} noCenter />
      <Container className="paragraph-group">
        <div className="row">
          {entity.get('field_paragraphs') ? (
            <div className="NodeBasicPage__paragraphs col-lg-7 col-12">
              {entity.get('field_paragraphs', List()).map((paragraph) => {
                const id = paragraph.get('target_id');
                const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
                return (
                  <Paragraph
                    key={`paragraph:${id}:${language}`}
                    id={id}
                    entity={paragraph.get('entity')}
                  />
                );
              })}
            </div>
          ) : null}
          <div className="col-lg-4 col-12 offset-lg-1" id="sidebar">
            <div id="sidebar-content">
              <View
                id={TESTIMONIAL_VIEW_ID}
                display={TESTIMONIAL_VIEW_BLOCK_3}
                page={currentPage}
                setCurrentPage={setCurrentPage}
                buttons={buttons}
              />
            </div>
          </div>
        </div>
      </Container>
    </article>
  );
};

export default NodeBasicPage;
